export interface ShareButtonProps {
    showShareButton: boolean;
    resultsWidgetLabel: string;
    popularProvidersWidgetLabel: string;
}

const ShareButton: React.FC<ShareButtonProps> = ({
    showShareButton,
    resultsWidgetLabel,
    popularProvidersWidgetLabel
}) => {
    if (!showShareButton) {
        return null;
    }

    return (
        <div data-filter-item="share-widget" className="dropdown hidden-xs hidden-sm">
            <button
                id="embed-modal-button"
                className="dropdown-toggle btn btn-default btn-sm font-4 rounded-2"
                type="button"
                aria-haspopup="true"
                aria-expanded="false"
                data-toggle="dropdown"
            >
                <span className="fa fa-share-alt"></span> <span className="caret"></span>
            </button>

            <ul className="dropdown-menu pull-right">
                <li>
                    <a href="#" data-toggle="modal" data-target="#share-search-results" title="Embed">
                        {resultsWidgetLabel}
                    </a>
                </li>
                <li>
                    <a href="#" data-toggle="modal" data-target="#share-popular-providers" title="Embed">
                        {popularProvidersWidgetLabel}
                    </a>
                </li>
            </ul>
        </div>
    );
};

export default ShareButton;
